<div class="button-strip">
	<div class="buttons-container">
		<ng-content select=".primary-area"></ng-content>
	</div>
	<div class="buttons-container take-available-width">
		<ng-content select=".adjustable-buttons-wrapper"></ng-content>
	</div>
	<div class="buttons-container">
		<ng-content select=".secondary-area"></ng-content>
	</div>
</div>
